"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBootstrapModal = exports.bootstrapModalProps = void 0;
const _abstract_1 = require("../../_abstract");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.bootstrapModalProps = {
    ..._abstract_1.abstractModalProps
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.useBootstrapModal = (props, ctx) => {
    const { close } = _abstract_1.useModal(props, ctx);
    return { close };
};
//# sourceMappingURL=Modal.hooks.js.map